import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IconButton } from '@fluentui/react';

import { Status, StatusClass, StatusIcon, StatusText } from '../constants/status';

export const AssetGroupStatus = ({
  i18n,
  isReadOnlyUser,
  assetGroupId,
  assetGroupStatus,
  onEditAssetGroupStatus,
}) => {
  switch (assetGroupStatus) {
    case Status.Active:
    case Status.Paused:
      return (
        <IconButton
          className={classNames(['appads-asset-group-status', StatusClass[assetGroupStatus]])}
          title={i18n.getString(StatusText[assetGroupStatus] || '')}
          ariaLabel={i18n.getString(StatusText[assetGroupStatus] || '')}
          disabled={isReadOnlyUser}
          iconProps={{ iconName: StatusIcon[assetGroupStatus] }}
          menuProps={{
            className: 'appads-asset-group-status-menu',
            items: [
              {
                key: 'Enabled',
                text: i18n.getString(_TL_('Enabled')),
                className: classNames('status-enabled', assetGroupStatus === Status.Active && 'selected'),
                iconProps: { iconName: 'StatusCircleInner' },
                onClick: () => onEditAssetGroupStatus(assetGroupId, Status.Active),
              },
              {
                key: 'Paused',
                text: i18n.getString(_TL_('Paused')),
                className: classNames('status-paused', assetGroupStatus === Status.Paused && 'selected'),
                iconProps: { iconName: 'Pause' },
                onClick: () => onEditAssetGroupStatus(assetGroupId, Status.Paused),
              },
            ],
          }}
        />
      );
    case Status.Expired:
      return (
        <IconButton
          className={classNames(['appads-asset-group-status', StatusClass[assetGroupStatus]])}
          title={i18n.getString(StatusText[assetGroupStatus] || '')}
          ariaLabel={i18n.getString(StatusText[assetGroupStatus] || '')}
          iconProps={{ iconName: StatusIcon[assetGroupStatus] }}
          disabled
        />
      );
    default:
      return null;
  }
};

AssetGroupStatus.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  isReadOnlyUser: PropTypes.bool,
  assetGroupId: PropTypes.string.isRequired,
  assetGroupStatus: PropTypes.string.isRequired,
  onEditAssetGroupStatus: PropTypes.func.isRequired,
};

AssetGroupStatus.defaultProps = {
  isReadOnlyUser: true,
};
